import { DiscountState } from 'src/types/redux';
import {
  FETCH_DISCOUNT_FAILURE,
  FETCH_DISCOUNT_REQUEST,
  FETCH_DISCOUNT_SUCCESS,
  DiscountActionType,
} from '../types/discountType';

const initialState = {
  loading: false,
  discountData: [],
  error: '',
};
export const itemDiscountReducer = (
  state = initialState,
  action: DiscountActionType
) => {
  switch (action.type) {
    case FETCH_DISCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_DISCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        discountData: action.payload,
      };
    case FETCH_DISCOUNT_FAILURE:
      return {
        ...state,
        laoding: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
